import { DialogTitleProps } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitleStyled, IconButtonStyled } from './DialogHeader.styles';

interface DialogHeaderProps extends DialogTitleProps {
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
}

export const DialogHeader: React.FC<DialogHeaderProps> = ({ children, onClose, ...other }) => {
  return (
    <DialogTitleStyled {...other}>
      {children}

      {onClose && (
        <IconButtonStyled aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButtonStyled>
      )}
    </DialogTitleStyled>
  );
};
